import React from 'react'
import ReactDOM from 'react-dom/client'

import { App } from './App'
import { signIn } from './App/utils/signin'

// Function to render the app with React 18
function renderApp() {
  const rootElement = document.getElementById('root')

  if (!rootElement) {
    console.error('Root element not found')
    return
  }

  const root = ReactDOM.createRoot(rootElement)
  root.render(React.createElement(App, {}, null))
}

signIn(process.env.BE_HOST || 'https://schnack-dev.local:3001/api')
  .then(() => {
    renderApp()
  })
  .catch(console.log)
